export default {
  common: { close: '關閉' },
  login: {
    welcomeBack: '歡迎回來', signInContinue: '登入以同步你的收藏', email: '電子郵件',
    emailPlaceholder: 'you@example.com', password: '密碼', passwordPlaceholder: '••••••••',
    signIn: '登入', signingIn: '登入中…', newHere: '還沒有帳號？', createAccount: '建立帳號',
    loginFailed: '登入失敗', loginError: '登入時發生錯誤'
  },
  register: {
    createAccountTitle: '建立帳號', startDiscovering: '只在你想同步收藏時需要帳號',
    name: '名稱', namePlaceholder: '你的名稱', confirmPassword: '確認密碼',
    confirmPasswordPlaceholder: '再次輸入密碼', minCharacters: '至少 6 個字元',
    createAccountBtn: '建立帳號', creatingAccount: '建立中…', alreadyHaveAccount: '已經有帳號？',
    signInLink: '登入', passwordsNotMatch: '兩次輸入的密碼不一致',
    registrationFailed: '註冊失敗', registrationError: '註冊時發生錯誤'
  }
};
